import StripePaymentContainer from '@/features/stripe-precheckout-payment-elements/StripePaymentContainer';

const PaymentSection = ({ plan, clientSecret, userEmail, onEmailChange }) => {
    return (
        <div className="relative mt-10">
            <div className="absolute top-0 left-0 right-0 h-full 
            bg-gradient-to-r from-[#F01E6F] to-[#EF6F5E] rounded-3xl"></div>
            <div className="relative pt-10 pb-8 px-6 rounded-t-3xl">
                <button className="absolute top-0 left-1/2 transform -translate-x-1/2
                 -translate-y-1/2 bg-[#FFD700] text-[#001C3D] text-xs font-semibold py-2.5 px-6 rounded-lg">
                    7-DAY FREE TRIAL
                </button>

                <div className="text-center text-white text-sm mb-5">
                    No commitment. Cancel anytime.
                </div>

                <StripePaymentContainer
                    plan={plan}
                    variant="new_precheckout"
                    clientSecret={clientSecret}
                    userEmail={userEmail}
                    onEmailChange={onEmailChange}
                />
            </div>
        </div>
    );
};

export default PaymentSection; 